import NavBar from '../components/navbar/navBar';
import EducationSection from '../components/educationSection'
import Footer from '../components/footer';

const EducationPage = () => {
    return (
        <>
            <NavBar/>
            <EducationSection/>
            <Footer/>
        </>
    );
}

export default EducationPage;
